import intl from "react-intl-universal";
import { useLocation } from "react-router-dom";

export const BaasPlaceholder = () => {
  const { pathname } = useLocation();

  return (
    <div className="app-card flex min-h-[320px] flex-col items-center justify-center p-8 text-center">
      <p className="text-xs font-semibold uppercase tracking-wider text-gray-400">
        {intl.get("status.comingSoon")}
      </p>
      <h1 className="mt-2 text-xl font-bold text-brand-dark dark:text-gray-100">
        {intl.get("baas.placeholder.title")}
      </h1>
      <p className="mt-2 max-w-md text-sm text-gray-500 dark:text-gray-400">
        {intl.get("baas.placeholder.description", { path: pathname })}
      </p>
    </div>
  );
};
